import * as React from 'react';
interface props {
    handleClick ?: React.MouseEventHandler<HTMLButtonElement>, 
  }
const AddMoreBtn = ({handleClick}: props) => {
    return (
        <button type='button' className='btn addMoreBtn' onClick={handleClick}>Add More</button>
    );
}

export default AddMoreBtn;